export default function on (el, ev, fn) {
  let cancelled = false

  const events = ev.split(' ')

  const add = el.on ? () => el.on(ev, fn) : () => el.addEventListener(ev, fn)
  const off = el.off ? () => el.off(ev, fn) : el.removeEventListener(ev, fn)

  let cancel = () => {
    if (cancelled) return
    cancelled = true

    events.forEach(eve => off(eve, fn))

    cancel = () => {}
  }

  events.forEach(eve => add(eve, fn))

  return cancel
}

export function once (el, ev, fn) {
  const off = on(el, ev, (...args) => {
    off()
    return fn(...args)
  })

  return off
}

export function when (el, ev) {
  let off
  const prom = new Promise(resolve => {
    off = prom.once(el, ev, resolve)
  })

  prom.off = off

  return prom
}
